export const UserRoles = {
  IMPERSONATE: "IMP",
  ACCEPT_AWARD: "ACCPT_AWD",
  ACCEPT_AWARD_VIEW: "ACCPT_AWD_VW",
  CHOOSE_LANGUAGE: "LANGUAGE",
  REFRESH_TOKEN: "REFRESH",
  IMPERSONATED: "IMPD",
  BROKER_CHOICE_ONE: "BC_ONE",
  BROKER_CHOICE_ALL: "BC_ALL",
  BROKER_CHOICE_NONE: "BC_NONE",
  BROKER_CHOICE_DISABLE: "BC_DISABLED",
  BROKER_CHOICE_VIEW: "BC_VIEW",
  OVERRIDE_FED_TAX_ENABLE: "TAXO_ON",
  OVERRIDE_FED_TAX_DISABLE: "TAXO_OFF",
  OVERRIDE_FED_TAX_HIDE: "TAXO_HIDE",
  OVERRIDE_FED_TAX_VIEW: "TAXO_VIEW",
}

export const AnalyticsActions = {
  "/dashboard": "NAV_AT_GLANCE",
  "/stock-awards": "NAV_STOCK_AWARDS",
  "/broker": "NAV_BROKER",
  '/more-about-stock': "NAV_FAQ",
}

export const ApplicationVersion = "1.0.69"
